import React from 'react';
import PropTypes from 'prop-types';
import Chat from 'sharedComponents/Chat';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';
import UserPresenter from 'presenters/UserPresenter';
import BidPresenter from 'presenters/BidPresenter';
import MessagePresenter from 'presenters/MessagePresenter';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';
import ChatPresenter, { buildChatCurrentUser } from 'presenters/ChatPresenter';
import LoanOfficerCard from './components/LoanOfficerCard';

import useStyles from './useStyles';

const ChatPage = props => {
  const classes = useStyles();
  const {
    isOnline,
    isParticipantOnline,
    currentUser,
    onMessageSend,
    onMessagesRead,
    onBack,
    loanOfficer,
    chat,
    bid,
    selectedChatUid,
    chatInfo,
    onOpenLoanOfficerPage,
    loanOfficerId,
    messages,
    isMessagesLoading,
  } = props;

  const chatParticipant = ChatPresenter.buildChatParticipantFromLoanOfficer(
    loanOfficerId,
    chatInfo,
    isParticipantOnline,
  );
  const chatCurrentUser = buildChatCurrentUser(currentUser, isOnline);

  const latestMessage = FirebaseChatPresenter.latestMessage(chat);
  const lastEventAt = MessagePresenter.formatedSentTimeFromNow(latestMessage);

  return (
    <div className={classes.paper}>
      <LoanOfficerCard
        loanOfficer={loanOfficer}
        isOnline={isParticipantOnline}
        onClick={onOpenLoanOfficerPage}
        lastEventAt={lastEventAt}
        bid={bid}
        onBack={onBack}
      />
      <div className={classes.chatBox}>
        <Chat
          chatCurrentUser={chatCurrentUser}
          chatParticipant={chatParticipant}
          isMessagesLoading={isMessagesLoading}
          messages={messages}
          chatUid={selectedChatUid}
          onMessageSend={onMessageSend}
          onMessagesRead={onMessagesRead}
        />
      </div>
    </div>
  );
};

ChatPage.propTypes = {
  chat: FirebaseChatPresenter.shape().isRequired,
  selectedChatUid: PropTypes.string.isRequired,
  loanOfficerId: PropTypes.number.isRequired,
  chatInfo: ChatPresenter.shape(),
  isParticipantOnline: PropTypes.bool.isRequired,
  bid: BidPresenter.shape(),
  onBack: PropTypes.func.isRequired,
  isOnline: PropTypes.bool.isRequired,
  currentUser: UserPresenter.shape().isRequired,
  loanOfficer: LoanOfficerPresenter.shape(),
  onMessageSend: PropTypes.func.isRequired,
  onMessagesRead: PropTypes.func.isRequired,
  onOpenLoanOfficerPage: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(MessagePresenter.shape()),
  isMessagesLoading: PropTypes.bool.isRequired,
};

ChatPage.defaultProps = {
  bid: {},
  messages: [],
  chatInfo: {},
  loanOfficer: {},
};

export default ChatPage;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/ChatPage/ChatPage.js